export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_19-ba470829e0fbe3ef29a668706ea54101.jpg";